import Q3 from './Q3';

export default Q3;
